"use client"

export const Textarea = ({ value, onChange, placeholder, rows = 4, className = "" }) => (
  <textarea
    className={`w-full rounded-lg px-4 py-3 text-black focus:outline-none focus:ring-2 transition-all duration-200 ${className}`}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    rows={rows}
  />
)
